import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root',
})
export class TooltipService {
   private tooltips: HTMLElement[] = [];

   registerTooltip(tooltip: HTMLElement) {
      this.tooltips.push(tooltip);
   }

   destroyAllTooltips() {
      this.tooltips.forEach((tooltip) => {
         tooltip.remove();
      });
      this.tooltips = [];
   }
}
